__turbopack_context__.v({
  "addIcon": "ManualHoldingsPanel-module__NJaznW__addIcon",
  "addIconOpen": "ManualHoldingsPanel-module__NJaznW__addIconOpen",
  "balanceGrid": "ManualHoldingsPanel-module__NJaznW__balanceGrid",
  "body": "ManualHoldingsPanel-module__NJaznW__body",
  "form": "ManualHoldingsPanel-module__NJaznW__form",
  "holdingEditor": "ManualHoldingsPanel-module__NJaznW__holdingEditor",
  "holdingSheet": "ManualHoldingsPanel-module__NJaznW__holdingSheet",
  "holdingsList": "ManualHoldingsPanel-module__NJaznW__holdingsList",
  "sheetHeader": "ManualHoldingsPanel-module__NJaznW__sheetHeader",
  "stockLogo": "ManualHoldingsPanel-module__NJaznW__stockLogo",
});
